import { render, staticRenderFns } from "./RequestDocument.vue?vue&type=template&id=2dd35e37&scoped=true&"
import script from "./RequestDocument.vue?vue&type=script&lang=js&"
export * from "./RequestDocument.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocument.vue?vue&type=style&index=0&id=2dd35e37&scoped=true&lang=css&"
import style1 from "@/assets/styles/tooltips.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd35e37",
  null
  
)

export default component.exports